// extracted by mini-css-extract-plugin
module.exports = {"root":"MainContainer_root__Q9FUw","borderDesktop":"MainContainer_borderDesktop__gBzTy"};